import React from 'react'

import Icon from '@/components/common/Icon'

const IconCalendar: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill="none"
    className={className}
  >
    <mask
      id="mask0_3004_2348"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="25"
    >
      <rect x="0.5" y="0.5" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3004_2348)">
      <path
        d="M5.80775 22C5.30258 22 4.875 21.825 4.525 21.475C4.175 21.125 4 20.6974 4 20.1922V6.80773C4 6.30257 4.175 5.87498 4.525 5.52498C4.875 5.17498 5.30258 4.99998 5.80775 4.99998H7.19225V2.88474H8.73075V4.99998H16.3077V2.88474H17.8077V4.99998H19.1923C19.6974 4.99998 20.125 5.17498 20.475 5.52498C20.825 5.87498 21 6.30257 21 6.80773V20.1922C21 20.6974 20.825 21.125 20.475 21.475C20.125 21.825 19.6974 22 19.1923 22H5.80775ZM5.80775 20.5H19.1923C19.2692 20.5 19.3398 20.4679 19.4038 20.4037C19.4679 20.3397 19.5 20.2692 19.5 20.1922V10.8077H5.5V20.1922C5.5 20.2692 5.53208 20.3397 5.59625 20.4037C5.66025 20.4679 5.73075 20.5 5.80775 20.5ZM5.5 9.30773H19.5V6.80773C19.5 6.73073 19.4679 6.66023 19.4038 6.59623C19.3398 6.53207 19.2692 6.49998 19.1923 6.49998H5.80775C5.73075 6.49998 5.66025 6.53207 5.59625 6.59623C5.53208 6.66023 5.5 6.73073 5.5 6.80773V9.30773Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export default Icon(IconCalendar)
